<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('payItemAllowance.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('payItemAllowance.allowanceItem') }}</label>
              <div>
                <ts-input
                  v-model="model.allowance_item"
                  :class="{ 'is-invalid': errors.has('allowance_item') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('allowance_item')">
                  {{ errors.first('allowance_item') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('payItemAllowance.fringeBenefitPercent')
              }}</label>
              <div>
                <ts-input
                  type="number"
                  v-model.number="model.fringe_benefit_percent"
                  :class="{
                    'is-invalid': errors.has('fringe_benefit_percent')
                  }"
                />
                <div class="invalid-feedback" v-if="errors.has('fringe_benefit_percent')">
                  {{ errors.first('fringe_benefit_percent') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('payItemAllowance.taxWithholdingPercent')
              }}</label>
              <div>
                <ts-input
                  v-model.number="model.tax_withholding_percent"
                  :class="{
                    'is-invalid': errors.has('tax_withholding_percent')
                  }"
                />
                <div class="invalid-feedback" v-if="errors.has('tax_withholding_percent')">
                  {{ errors.first('tax_withholding_percent') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <ts-checkbox v-model="model.is_taxable">{{ $t('payItemAllowance.isTaxable') }}</ts-checkbox>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2"
              :waiting="savingAndNew"
              @click.prevent="saveAndNew"
              v-if="editData === undefined"
              >{{ $t('button.createAndNew') }}</ts-button
            >
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">{{
              editData ? $t('button.update') : $t('button.create')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'

export default {
  name: 'pay-item-allowance-form',
  props: ['editData'],
  data() {
    const model = {
      allowance_item: this.editData ? this.editData.allowance_item : '',
      is_taxable: this.editData ? this.editData.is_taxable : false,
      fringe_benefit_percent: this.editData ? this.editData.fringe_benefit_percent : 0,
      tax_withholding_percent: this.editData ? this.editData.tax_withholding_percent : 0
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false
    }
  },
  methods: {
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/payItemAllowance/update', {
          id: this.editData.allowance_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/payItemAllowance/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/payItemAllowance/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
